export function formatInteger(value) {
  if (value == null || Number.isNaN(Number(value)) || value === 0) {
    return '—'
  }

  return Number(value).toLocaleString()
}
